import { useField, useFormikContext } from 'formik';
import { GMFormPhoneField } from '..';
import { GoMotoComponent } from '../../../API/GoMoto.types';
import { useAppointmentState, useTexting } from '../../../context/Appointment/appointment';
import { FormCustomerDetailsPhoneFieldProps } from './FormCustomerDetailsPhoneField.types';
import { useEffect, useRef } from 'react';
import { IAppointment } from '../../../API/GoMoto';

/**
 * A phone field wrapper that is used exclusively by the `CustomerDetails` and `TowInDetails` screen. On mount and any time
 * the value of the field has changed and is a complete phone number, we call the `checkPhoneTextingStatus` function from
 * the {@link useTexting} hook to update whether the current phone number is deliverable and if they have opted-in/opted-out of texting.
 *
 * @param name - {@link FormCustomerDetailsPhoneFieldProps.name name} description.
 * @param optInStatusFieldName - {@link FormCustomerDetailsPhoneFieldProps.optInStatusFieldName optInStatusFieldName} description.
 * @param optInStatus - {@link FormCustomerDetailsPhoneFieldProps.optInStatus optInStatus} description.
 * @param setOptInStatus - {@link FormCustomerDetailsPhoneFieldProps.setOptInStatus setOptInStatus} description.
 * @param props - {@link GMFormPhoneField props} description.
 */
const FormCustomerDetailsPhoneField: GoMotoComponent<FormCustomerDetailsPhoneFieldProps> = ({
    name,
    optInStatusFieldName,
    optInStatus,
    setOptInStatus,
    textingActive,
    ...props
}) => {
    const [field] = useField(name);
    const { setFieldValue } = useFormikContext();
    const appointment: IAppointment = useAppointmentState();
    const { checkPhoneTextingStatus } = useTexting();
    const isLoadingRef = useRef<boolean>(false);

    useEffect(() => {
        if (
            textingActive && field.value && field.value.length === 10 && !isLoadingRef.current &&
            (optInStatus === undefined || (optInStatus !== undefined && optInStatus.phone !== field.value))
        ) {
            isLoadingRef.current = true;

            checkPhoneTextingStatus(field.value)
                .then(({ data }) => {
                    isLoadingRef.current = false;
                    setFieldValue(optInStatusFieldName, data.status);
                    setOptInStatus(data);
                })
                .catch(() => {
                    isLoadingRef.current = false;
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        appointment.phone,
        field.value,
        setOptInStatus,
        setFieldValue,
        optInStatusFieldName,
    ]);

    return (
        <GMFormPhoneField
            name={name}
            {...props}
        />
    );
};

export default FormCustomerDetailsPhoneField;